<template>
    <div class="container-fluid">
        <Breadcrumb title="PMTA Relays" button-url="pmtaRelayCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-info btn-rounded mr-2 mb-2" @click="bulkMove()"
                                v-bind:disabled="!selectedRelays.length">
                                <i class="fas fa-share"></i>
                                Move to Group
                            </button>
                            <button type="button" class="btn btn-info btn-rounded mr-2 mb-2" @click="bulkActivity()"
                                v-bind:disabled="!selectedRelays.length">
                                <i class="fa fa-edit"> </i>
                                Change Activity
                            </button>
                            <button type="button" class="btn btn-danger btn-rounded mr-2 mb-2" @click="bulkDelete()"
                                v-bind:disabled="!selectedRelays.length">
                                <i class="far fa-trash-alt"></i>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by owner" v-model="filter.userId" :multiple="false"
                                    :options="userList" :load-options="loadUserList" />
                            </div>
                            <div class="form-group">
                                <label>Relay Type</label>
                                <treeselect v-model="filter.isVps" placeholder="Type" :clearable=false :multiple="false"
                                    :options="relayTypeSelect" />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by group" v-model="filter.groupId" :multiple="false"
                                    :options="groupList" :load-options="loadGroupList"
                                    :disabled="Boolean(this.groupId)" />
                            </div>
                            <div class="form-group">
                                <treeselect placeholder="Search by PMTA server" v-model="filter.serverId"
                                    :multiple="false" :options="serverList" :load-options="loadServerList"
                                    :disabled="Boolean(this.serverId)" />
                            </div>
                            <div class="input-group form-group">
                                <input v-model="filter.smtpHost" type="text" class="form-control form-control-line"
                                    placeholder="Search by SMTP Host">
                            </div>
                            <input v-model="filter.description" type="text" class="form-control form-control-line"
                                placeholder="Search by Description">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button"
                                    v-bind:disabled="relayId || serverId || groupId">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                            <span>Total:
                                <span class="label label-info">{{ totalItems }}</span>
                            </span>&nbsp;&nbsp;&nbsp;
                            <span v-if="poorRelaysCount !== 0">Poor:
                                <span class="label label-danger">{{ poorRelaysCount }}</span>
                            </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{ preloader: loading }"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="relayList.length > 0">
                                <div id="relayReputationsHtml" v-show="false">
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Provider</th>
                                                    <th>Reputation</th>
                                                    <th>Detail</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(reputation, index) in relayReputations" :key="index">
                                                    <td>{{ reputation.provider.name }}</td>
                                                    <td>{{ reputation.reputation }}</td>
                                                    <td>{{ reputation.details }}</td>
                                                    <td>{{ (reputation.date ?
                                                        moment.utc(reputation.date.toString()).format('D/M/YYYY H:mm') :
                                                        '-')}}
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div id="bulkMoveHtml" v-show="false">
                                    <select class="form-control" v-model="bulkGroupSelect" ref='bulkMoveHtml'>
                                        <option disabled value="null">Select group</option>
                                        <option v-for="(group, index) in groupList" :key="index"
                                            v-bind:value="group.id">{{ group.label }}</option>
                                    </select>
                                </div>
                                <div id="bulkActivityHtml" v-show="false">
                                    <select class="form-control" v-model="bulkActivitySelect" ref='bulkActivityHtml'>
                                        <option disabled value="null">Select status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                    </select>
                                </div>
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th><input type="checkbox" v-model="selectAllRelays"
                                                        @click="selectAll()"></th>
                                                <th @click="tableOrdering('id')"><span role='button'>ID</span></th>
                                                <th @click="tableOrdering('pmtaServer.isVps')">
                                                    <span role='button'>Type</span>
                                                </th>
                                                <th @click="tableOrdering('smtpHost')">
                                                    <span role='button'>Smtp Host</span>
                                                </th>
                                                <th @click="tableOrdering('ip')"><span role='button'>IP</span></th>
                                                <th @click="tableOrdering('pmtaServer.name')">
                                                    <span role='button'>Pmta Server</span>
                                                </th>
                                                <th @click="tableOrdering('group.name')">
                                                    <span role='button'>Group</span>
                                                </th>
                                                <th @click="tableOrdering('status')"><span role='button'>Status</span>
                                                </th>
                                                <th @click="tableOrdering('active')"><span role='button'>Active</span>
                                                </th>
                                                <th @click="tableOrdering('description')"><span
                                                        role='button'>Description</span></th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr :key="index" v-for="(relay, index) in relayList">
                                                <td class="align-middle">
                                                    <input type="checkbox" v-model="selectedRelays" :value="relay.id">
                                                </td>
                                                <td class="align-middle">{{ relay.id }}</td>
                                                <td class="align-middle">{{ (relay.pmtaServer.isVps ? 'VPS' : 'Net') }}
                                                </td>
                                                <td class="align-middle">{{ relay.smtpHost }}</td>
                                                <td class="align-middle">{{ relay.ip }}</td>
                                                <td class="align-middle">{{ relay.pmtaServer.name }}</td>
                                                <td class="align-middle">{{ relay.group.name }}</td>
                                                <td class="align-middle">
                                                    <button @click="getRelayReputations(relay.id, relay.smtpHost)"
                                                        class="btn btn-sm" v-bind:class="buttons[relay.status]"
                                                        type="button">
                                                        {{ statuses[relay.status] }}
                                                        <div v-if="waitReps === relay.id"
                                                            class="spinner-grow spinner-grow-sm" role="status"></div>
                                                    </button>
                                                </td>
                                                <td class="align-middle">{{ relay.active }}</td>
                                                <td class="align-middle">{{ relay.description }}</td>
                                                <td class="align-middle">
                                                    <router-link
                                                        :to="{ name: 'pmtaRelayEdit', params: { id: relay.id } }"
                                                        class="btn btn-sm btn-info m-r-10">
                                                        <i class="fa fa-edit"></i> Edit
                                                    </router-link>
                                                    <!--<button @click="getRelayDkim(relay.id)"
                                                        class="btn btn-sm btn-success m-r-10"
                                                        type="button">
                                                    <i class="fa fa-key"></i> Get DKIM
                                                    <div v-if="waitDkim === relay.id"
                                                         class="spinner-grow spinner-grow-sm" role="status"></div>
                                                </button>-->
                                                    <button @click="deleteRelay(relay.id)" class="btn btn-sm btn-danger"
                                                        type="button">
                                                        <i class="far fa-trash-alt"></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate :click-handler="getItems"
                                    :container-class="'pagination justify-content-center pt-2'" :margin-pages="2"
                                    :next-class="'page-item'" :next-link-class="'page-link'" :next-text="'Next'"
                                    :page-class="'page-item'" :page-count="pageCount" :page-link-class="'page-link'"
                                    :page-range="3" :prev-class="'page-item'" :prev-link-class="'page-link'"
                                    :prev-text="'Prev'" v-if="pageCount > 1" v-model="filter.page">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import PmtaRelayService from '../services/PmtaRelayService';
import UserService from '../services/UserService';
import PmtaRelayGroupService from '../services/PmtaRelayGroupService';
import Preloader from '../components/Preloader';
import Breadcrumb from '../components/Breadcrumb';
import PmtaServerService from '../services/PmtaServerService';
import Treeselect from '@riophae/vue-treeselect';
import paginateMixin from '../mixins/paginate-mixin';
import { RelayStatus } from '../constants';

export default {
    name: 'PmtaRelays',
    props: ['serverId', 'groupId', 'relayId'],
    components: {
        Preloader, Breadcrumb, Treeselect
    },
    mixins: [paginateMixin],
    data() {
        return {
            relayList: [],
            userList: null,
            groupList: null,
            serverList: null,
            loading: false,
            waitDkim: null,
            waitReps: null,
            totalItems: 0,
            statuses: RelayStatus.value,
            buttons: RelayStatus.buttons,
            relayReputations: [],
            selectedRelays: [],
            selectAllRelays: false,
            bulkGroupSelect: null,
            bulkActivitySelect: null,
            relayTypeSelect: [
                { id: 'All', label: 'All' },
                { id: true, label: 'VPS' },
                { id: false, label: 'Net' }
            ],
            poorRelaysCount: 0,
            filter: {
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                orderBy: 'id',
                orderDirection: 'asc',
                smtpHost: null,
                userId: null,
                groupId: null,
                serverId: null,
                relayId: null,
                isVps: 'All',
                description: null
            },
        }
    },
    mounted() {
        this.getItems();
    },
    methods: {
        getItems: function () {
            if (this.filter.isVps === 'All') {
                this.filter.isVps = null;
            }
            this.selectedRelays = [];
            this.selectAllRelays = false;
            this.loading = true;
            this.filter.groupId = this.groupId ? this.groupId : this.filter.groupId;
            this.filter.serverId = this.serverId ? this.serverId : this.filter.serverId;
            this.filter.relayId = this.relayId ? this.relayId : this.filter.relayId;
            PmtaRelayService.getRelays(this.filter).then(response => {
                this.relayList = response.data['hydra:member'];
                this.totalItems = response.data['hydra:totalItems'];
                this.loading = false;
            });
            this.getPoorRelaysCount();
        },
        getPoorRelaysCount: function () {
            this.poorRelaysCount = 0;
            this.filter.groupId = this.groupId ? this.groupId : this.filter.groupId;
            this.filter.serverId = this.serverId ? this.serverId : this.filter.serverId;
            this.filter.relayId = this.relayId ? this.relayId : this.filter.relayId;
            PmtaRelayService.getPoorRelaysCount(this.filter).then(response => {
                this.poorRelaysCount = response.data.count;
            });
        },
        search: function () {
            this.filter.page = 1;
            this.getItems();
        },
        deleteRelay(id) {
            Swal({
                title: 'Are you sure you want to delete?',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaRelayService.deleteRelay(id).then((response) => {
                        if (response.status === 204) {
                            let relayIndex = this.relayList.findIndex(obj => obj.id === id);
                            this.relayList.splice(relayIndex, 1);
                            this.totalItems--;
                        }
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    Swal(
                        'Deleted successfully!',
                        `Relay has been deleted.`,
                        'success'
                    )
                }
            })
        },
        getRelayDkim(id) {
            this.waitDkim = id;
            PmtaRelayService.getRelayDkim(id).then(response => {
                Swal({
                    type: response.text.startsWith("Error:") ? 'error' : '',
                    title: 'Relay DKIM public key:',
                    html: response.text,
                    confirmButtonText: 'Close',
                });
                this.waitDkim = null;
            });
        },
        async getRelayReputations(id, relayHost) {
            this.waitReps = id;
            let swalHtml = '';
            await PmtaRelayService.getRelayReputations(id).then(response => {
                if (response.status === 200) {
                    this.relayReputations = response.data.reputations;
                } else {
                    swalHtml = (response.data.error === undefined) ? response.status + ': ' + response.statusText : response.data.error[0]
                }
                this.waitReps = null;
            }).catch(error => {
                this.waitReps = null;
                swalHtml = error;
            });
            await Swal({
                width: '70%',
                title: relayHost + ' reputations:',
                html: swalHtml === '' ? document.getElementById('relayReputationsHtml').innerHTML : swalHtml,
                confirmButtonText: 'Close',
            });
        },
        tableOrdering(field) {
            if (this.filter.orderBy === field) {
                this.filter.orderDirection = (this.filter.orderDirection === 'asc') ? 'desc' : 'asc';
            } else {
                this.filter.orderBy = field;
                this.filter.orderDirection = 'asc';
            }
            this.filter.page = 1;
            this.getItems();
        },
        loadUserList({ callback }) {
            UserService.getUserSelect().then(response => {
                this.userList = response.data['hydra:member'].map(user => {
                    return { id: user.id, label: user.username }
                });
                callback();
            });
        },
        loadGroupList({ callback }) {
            PmtaRelayGroupService.getGroupSelect().then(response => {
                this.groupList = response.data['hydra:member'].map(group => {
                    return { id: group.id, label: group.name }
                });
                callback(this.filter.groupId = this.groupId);
            });
        },
        loadServerList({ callback }) {
            PmtaServerService.getServerSelect().then(response => {
                this.serverList = response.data['hydra:member'].map(server => {
                    return { id: server.id, label: server.name }
                });
                callback(this.filter.serverId = this.serverId);
            });
        },
        selectAll() {
            this.selectedRelays = [];
            if (!this.selectAllRelays) {
                for (let relay of this.relayList) {
                    this.selectedRelays.push(relay.id);
                }
            }
        },
        bulkMove() {
            Swal({
                type: 'question',
                title: 'Which group to move to?',
                html: this.$refs.bulkMoveHtml,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaRelayService.bulkMove(this.selectedRelays, this.bulkGroupSelect).catch(error => {
                        Swal.showValidationMessage('Error: ' + error.response.data.error[0]);
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value.status === 200) {
                    Swal('Successfully moved!');
                    this.filter.page = 1;
                    this.getItems();
                } else {
                    Swal(result.value.statusText, result.value.data.error[0]);
                }
            })
        },
        bulkActivity() {
            Swal({
                type: 'question',
                title: 'What status to assign?',
                html: this.$refs.bulkActivityHtml,
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaRelayService.bulkActivity(this.selectedRelays, this.bulkActivitySelect).catch(error => {
                        Swal.showValidationMessage('Error: ' + error.response.data.error[0]);
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value.status === 200) {
                    Swal('Successfully changed!');
                    this.filter.page = 1;
                    this.getItems();
                } else {
                    Swal(result.value.statusText, result.value.data.error[0]);
                }
            })
        },
        bulkDelete() {
            Swal({
                type: 'question',
                title: 'Are you sure you want to delete ' + this.selectedRelays.length + ' selected relays?',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return PmtaRelayService.bulkDelete(this.selectedRelays).catch(error => {
                        Swal.showValidationMessage('Error: ' + error.response.data.error[0]);
                    });
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                if (result.value.status === 200) {
                    Swal('Deleted successfully!');
                    this.filter.page = 1;
                    this.getItems();
                } else {
                    Swal(result.value.statusText, result.value.data.error[0]);
                }
            })
        }
    },
    computed: {
        pageCount: function () {
            return Math.ceil(this.totalItems / this.filter.perPage);
        }
    }
}
</script>

<style scoped></style>